import Vuex from "vuex";
import Vue from "vue";
import Global from "../../utils/Global";
import api from "../../axios/api";
import {
  trevelNotesdetail,
  trevelNotesDetailOld,
  searchTravelList
} from "@/axios/service/travel.js";
Vue.use(Vuex);
const NewTravelStore = {
  namespaced: true,
  state: {
    newTravelsList: [],
    total: 0,
    findtreveldetail: ""
  },
  mutations: {
    newTravelsListMutations(state, value) {
      state.newTravelsList = value;
    },
    totalMutations(state, value) {
      state.total = value;
    },
    //游记
    findtreveldetailMutation(state, value) {
      state.findtreveldetail = value;
    }
  },
  actions: {
    getnewTravelsList(context, params) {
      searchTravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          context.commit("newTravelsListMutations", json.data);
          let realTotal = json.total;
          if (realTotal > 50) {
            realTotal = 50;
          }
          context.commit("totalMutations", realTotal);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    findTravelDetailOld(context, params) {
      if (params.fromWhere === "preview") {
        Global.messageSuc("已自动保存草稿");
        delete params.fromWhere;
      }
      trevelNotesDetailOld(params).then(json => {
        if (json.respCode === 100 && json !== undefined) {
          context.commit("findtreveldetailMutation", [json.data]);
        } else {
          context.commit("findtreveldetailMutation", []);
        }
      });
    },
    //获取游记详情
    findtrevelNotesdetail(context, params) {
      if (params.fromWhere === "preview") {
        Global.messageSuc("已自动保存草稿");
        delete params.fromWhere;
      }
      trevelNotesdetail(params).then(json => {
        if (json.respCode === 100 && json !== undefined) {
          context.commit("findtreveldetailMutation", [json.data]);
        } else {
          context.commit("findtreveldetailMutation", []);
        }
      });
    }
  }
};

export default NewTravelStore;
